
import {ProjectMeta} from "@/models/project.meta";

/**
 *
 * @function ProjectFactoryDecorator
 *
 * To manage circular dependencies among Project, ProjectElement (and subclasses) and
 * ProjectElementFactory, we register the constructors for classes in a "Meta" class
 * similar to the technique from:
 *
 *   https://stackoverflow.com/questions/44134469/typescript-nodejs-circular-dependency-while-working-with-factories
 *
 * Once we have the constructors registered by class name, we can create new instances
 * of project elements by class name without an explicit reference to the type in
 * factory.  This avoids the direct type <=> type circular loop.
 *
 * The decorator that "registers" a class's constructor with our "Meta" class is
 * defined here as the
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2022
 *
 */
export function ProjectFactoryDecorator(className: string) {

  return (target: any) => {

    ProjectMeta.register(className, target);
  };
}
